'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Button } from '../button/button.js';

/**
 * SearchButton component, used to display a search button within a Search component.
 *
 * @example
 * <Search>
 *   <SearchInput aria-label='Søk' />
 *   <SearchButton>Søk</SearchButton>
 * </Search>
 */
const SearchButton = forwardRef(function SearchButton({ children = 'Søk', ...rest }, ref) {
    return (jsx(Button, { ref: ref, type: 'submit', ...rest, children: children }));
});

export { SearchButton };
